export enum CreateEditUserTypes {
    CREATE_USER = 'CREATE_USER',
    EDIT_USER = 'EDIT_USER',
    ADD_EXISTING_USER = 'ADD_EXISTING_USER',
}
